import { Footer } from '@/previewThemes/kinetic/Footer';
import { Header } from '@/previewThemes/kinetic/Header';
import { Product } from '@/previewThemes/kinetic/Product';
import {
  kineticProductParts,
  kineticProductSections,
} from '@/previewThemes/kinetic/productPage';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // The cart opens as a drawer from the right - from the header's cart link
  // and after "Add to cart" - so a shopper adding kit never leaves the page.
  quickCart: true,
  listing: {
    // Four across, with the filters in a row of chips above rather than a
    // rail beside: a sports catalogue is scanned as a wall of kit, and the
    // full page width is what fits four charcoal tiles at a readable size.
    grid: 'grid-cols-2 gap-5 lg:grid-cols-3 xl:grid-cols-4',
    filters: 'chips',
    columns: 4,
    // Every card sits on a charcoal tile, the picture above and the name and
    // price on the tile below it.
    card: 'framed',
  },
  cart: { grid: 'mt-8 grid gap-8 lg:grid-cols-3', panel: 'filled' },
  checkout: {
    grid: 'mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_24rem] lg:gap-12',
    panel: 'filled',
  },
  search: {
    grid: 'mt-8 grid gap-8 lg:grid-cols-[240px_1fr]',
    results: 'grid grid-cols-2 gap-5 lg:grid-cols-3 xl:grid-cols-4',
    columns: 4,
    card: 'framed',
    panel: 'filled',
  },
  blog: { list: 'grid gap-8 sm:grid-cols-2 lg:grid-cols-3', title: 'text-2xl' },
  category: { grid: 'grid gap-5 sm:grid-cols-2 lg:grid-cols-4', tile: 'card' },
  pages: {
    product: { defaults: kineticProductSections },
  },
  parts: {
    product_details: {
      defaults: kineticProductParts,
      presentation: {
        classes: {
          product_title: 'text-4xl sm:text-5xl leading-none',
          product_price: 'text-2xl font-semibold',
          product_short_description: 'text-[15px]',
        },
        wideButtons: true,
        gallery: { aspect: 'square', thumbs: 'below' },
      },
    },
  },
};
